const BaseModule = require('../../../../90_utils/base/BaseModule');

class ExpandingPhotoCols extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$navItems = this.$el.find('> ul > li');
		this.$photos = this.$el.find('> ul > li .photo');
		this.$photoItems = this.$el.find('.photo-items');

		this.numPhotos = this.$photos.length;
		this.isHover = false;
	}

	// basemodule methods

	_domReady(){

	}

	_addListeners(){

		this.$navItems.on('click', $.proxy(this._onPhotoTap, this));

		this.$photoItems.on('mouseenter', $.proxy(this._onPhotoItemsOver, this));
		this.$photoItems.on('mouseleave', $.proxy(this._onPhotoItemsOut, this));
	}

	_removeListeners(){

		this.$photoItems.off('mousemove', $.proxy(this._onMouseMove, this));
	}

	//

	_onPhotoItemsOver(){
		if(!this.isHover){
			this.isHover = true;
			this.$photoItems.on('mousemove', $.proxy(this._onMouseMove, this));
		}
	}

	_onPhotoItemsOut(){
		if(this.isHover){
			this.isHover = false;
			this.$photoItems.off('mousemove', $.proxy(this._onMouseMove, this));
			this._restorePhotos();
		}
	}

	_onMouseMove(e){

		if(window.SETTINGS.breakpoint.minWidth('screen-small')){

			let pageX = window.SETTINGS.coords.pageX;
			let bounds = this.$photoItems.offset();
			bounds.width = this.$photoItems.outerWidth();

			let photoIndex = Math.round(((pageX - (bounds.left + bounds.width)) / bounds.width + 1) * (this.numPhotos - 1));

			this._expandPhoto(this.$navItems.eq(photoIndex));
		}
	}

	_onPhotoTap(e){

		if(window.SETTINGS.breakpoint.maxWidth('screen-small')){
			let $target = $(e.currentTarget);
			let $navItem = $target.closest('.photo-item');
			this._expandPhoto($navItem);

			window.requestAnimationFrame(() => {
				$('body').on('click', $.proxy(this._onOut, this));
			});
		}
	}

	_onOut(e){
		if(!this.$photoItems[0].contains(e.target)){
			$('body').off('click', $.proxy(this._onOut, this));
			this._restorePhotos();
		}
	}

	//

	_expandPhoto($navItem){

		if(!$navItem.hasClass('is-active') && window.SETTINGS.breakpoint.minWidth('screen-phablet')){

			let $photo = $navItem.find('.photo');
			let $cropMask = $photo.find('.crop-mask');
			let $croppedPhoto = $photo.find('.cropped-photo');
			let $description = $navItem.find('.description');
			let fullWidth = $croppedPhoto.outerWidth();
			let photoWidth = $photo.outerWidth();
			let photoHeight = $photo.outerHeight();

			let totalWidth = photoWidth * 4; // + 20 * 3;
			let squishedWidth = Math.round((totalWidth - fullWidth)/3);
			let squishedDiff = photoWidth - squishedWidth;
			let navItemIndex = $navItem.index();
			let cropX = 0 - squishedDiff * navItemIndex;

			this.$navItems.removeClass('is-active');
			$navItem.addClass('is-active');

			window.requestAnimationFrame(() => {

				TweenMax.killTweensOf([$description, $cropMask, $croppedPhoto]);
				TweenMax.to($cropMask, 0.3, {x:cropX, clip:`rect(0px ${fullWidth}px ${photoHeight}px 0px)`, ease:'fade'});
				TweenMax.to($description, 0.3, {x: Math.round(cropX + (fullWidth - photoWidth)/2), opacity:1, ease:'fade'});
				TweenMax.to($croppedPhoto, 0.3, {x: 0, ease:'fade'});

				this.$navItems.each((index, value) => {

					let $tNavItem = $(value);

					if($tNavItem[0] !== $navItem[0]){

						let tCropX = fullWidth - photoWidth - squishedDiff * (index - 1);
						if(index < navItemIndex){ tCropX = 0 - squishedDiff * index; }

						let $tCropMask = $tNavItem.find('.crop-mask');
						let $tDescription = $tNavItem.find('.description');

						TweenMax.killTweensOf([$tDescription, $tCropMask, $tNavItem]);
						TweenMax.to($tDescription, 0.2, {opacity:0, ease:'fade'});
						TweenMax.to($tCropMask, 0.3, {x:tCropX, clip:`rect(0px ${squishedWidth}px ${photoHeight}px 0px)`, ease:'fade'});
					}
				});
			});
		}
	}

	_restorePhotos(){

		this.$navItems.each((index, value) => {

			let $navItem = $(value);
			let $description = $navItem.find('.description');
			let $photo = $navItem.find('.photo');
			let $cropMask = $photo.find('.crop-mask');
			let $croppedPhoto = $photo.find('.cropped-photo');

			let croppedWidth = $photo.outerWidth();
			let photoHeight = $photo.outerHeight();
			let photoX = Math.round(0 - ($croppedPhoto.outerWidth() - $photo.outerWidth())/2);

			TweenMax.killTweensOf([$description, $cropMask, $croppedPhoto]);

			if($navItem.hasClass('is-active')){
				TweenMax.to($description, 0.3, {x:0, ease:'fade'});
			}
			else {
				let delay = 0.28;
				TweenMax.to($description, 0.3, {opacity:1, delay:delay, ease:'fade'});
				TweenMax.to($description, 0.1, {x:0, ease:'fade'});
			}

			TweenMax.to($cropMask, 0.3, {x:0, clip:`rect(0px ${croppedWidth}px ${photoHeight}px 0px)`, ease:'fade'});
			TweenMax.to($croppedPhoto, 0.3, {x: photoX, ease:'fade', onComplete:() => {
				if($navItem.hasClass('is-active')){
					$navItem.removeClass('is-active');
				}
			}});
		});
	}

	//

	_show(){}

	_hide(){}

	_enable(){ }
	_disable(){ }

	_domUpdate(){

	}
	_resize(){

		this.$photos.each((index, value) => {

			let $photo = $(value);
			let $cropMask = $photo.find('.crop-mask');
			let $croppedPhoto = $photo.find('.cropped-photo');
			let croppedWidth = $photo.outerWidth();
			let photoHeight = $photo.outerHeight();
			let photoWidth = window.SETTINGS.breakpoint.minWidth('screen-small') ? photoHeight * (3/2) : croppedWidth;
			let photoX = Math.round(0 - (photoWidth - $photo.outerWidth())/2);

			TweenMax.set([$cropMask, $croppedPhoto], {width: photoWidth, height: photoHeight});
			TweenMax.set($cropMask, {clip:`rect(0px ${croppedWidth}px ${photoHeight}px 0px)`});
			TweenMax.set($croppedPhoto, {x:photoX});
		});

		this._restorePhotos();
	}
}

module.exports = ExpandingPhotoCols;
